import React from "react"
import { Container, Row, Col } from "reactstrap"
import Link from "./link"
import styled from "styled-components"
import footerItems from "../data/footer.json"
import NumberFormat from 'react-number-format'
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFax } from "react-icons/fa"
import Styled from "styled-components"

let Cirle = Styled.div`
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FooterStyling = styled.footer`
  padding: 3rem 0;
  background: #f8f9fa;
  a,
  a:hover {
    color: inherit;
  }
  ul {
    color: rgba(0, 0, 0, 0.5);
    -webkit-padding-start: 0;
    padding: 0;
    & > li {
      list-style: none;
      a,
      a:hover {
        color: inherit;
      }
    }
  }
`

let SocialLink = ({ Icon }) => (
  <Link to="/" className="mr-2">
    <Icon size={30} />
  </Link>
)

let FooterLink = ({ to, children }) => (
  <li>
    <Link to={to}>{children}</Link>
  </li>
)

let ContactItem = ({ text, type, Icon, href, children }) => (
  <Row className="d-flex align-items-center" >
    <Col xs={1} md={1} className="mr-2">
      <Cirle className="h-4-rem w-4-rem bg-primary-faded my-1 absolute-center rounded-circle">
        <Icon size={15} />
      </Cirle>
    </Col>
    <Col xs={10} md={10}>
      <p className="text-secondary my-0">
        {href ? (
          <Link to={href} className="reset">
            {children ? children : text}
          </Link>
        ) : (
          children ? children : text
        )}
      </p>
    </Col>
  </Row>
)

let Footer = () => (
  <FooterStyling>
    <Container>
      <Row className="d-flex align-items-center" >
        <Col xs={12} md={7} className="mb-3">
          <h1 style={{color: '#A00429'}}>Let's brew this together!</h1>
        </Col>
        
        {/* {footerItems.map((item) => (
          <Col key={item.name} xs={12} md={3}>
            <h5>{item.name}</h5>
            <ul>
              {item.dropdownItems.map((dropdownItem) => (
                <FooterLink key={dropdownItem.id} to={dropdownItem.url}>
                  {dropdownItem.name}
                </FooterLink>
              ))}
            </ul>
          </Col>
        ))} */}
        {/* <Col xs={12} md={3}>
          <h5>Contact Us</h5>
          <SocialLink Icon={FaFacebookSquare} />
          <SocialLink Icon={FaInstagram} />
        </Col> */}
        <Col xs={12} md={5}>
          <h5 className="d-none d-sm-block">Contact Us</h5>
          <ContactItem
            text="+603-8682 4038"
            href={`tel:+603-8682 4038`}
            Icon={FaPhone}
          >
            <NumberFormat value="+603-8682 4038" displayType={'text'} format="### #### ####"/>
          </ContactItem>
          <ContactItem
            text="sales@2q.my"
            href={`mailto:sales@2q.my`}
            type="Email"
            Icon={FaEnvelope}
          />
          <ContactItem text="A-4-12 Connection Commercial, Persiaran IRC3 IOI Resort City, 62502 Putrajaya, Sepang, Selangor" type="Address" Icon={FaMapMarkerAlt} />
        </Col>
      </Row>
    </Container>
  </FooterStyling>
)
export default Footer
